// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingPage_loadingContainer__vX9xC","loading":"LoadingPage_loading__4-ZCr"};